import { createEnvironmentProjectAtoms } from "@afar-research/client-runtime/state/projects";
import { createProjectEnvironmentAtoms } from "@afar-research/client-runtime/state/projects";

import { hostEnvironment } from "../connection/hostEnvironment";
import { connectionAtomRuntime } from "../connection/runtime";
import { environmentSnapshotAtom } from "./shell";

export const projectEnvironment = createProjectEnvironmentAtoms(connectionAtomRuntime);
export const environmentProjects = createEnvironmentProjectAtoms({
  environmentEntriesValueAtom: hostEnvironment.environmentEntriesValueAtom,
  snapshotAtom: environmentSnapshotAtom,
});
